import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { BaseService } from './baseservice';

import { FlowItemViewModel } from '../models/FlowItemModel';
import { ReportSearchParameters } from '../models/ReportSearchParameters';
import { PlayerContactModel, PlayerTagPlayerViewModel, PlayerTagViewModel } from '../models/player.model';
import { ResponseModel } from '../models/ResponseModel';

@Injectable({
  providedIn: 'root'
})
export class ScoutingPlayerService extends BaseService {
  
  constructor(private http: HttpClient) {
    super();
   }


   getPlayerDetails(playerid: string): Observable<any>{
    
    let ret = this.http.get<any>(this.rootUrl + '/api/scouting/playerflow/' + playerid );
    return ret;
   }

   getPlayerContacts(playerid: string): Observable<any>{
    
    let ret = this.http.get<any>(this.rootUrl + '/api/load/player/' + playerid + "/contacts" );
    return ret;
   }
   
   updatePlayerContact(contact: PlayerContactModel ): Observable<any>{
    
    let ret = this.http.put<any>(this.rootUrl + '/api/load/player/' + contact.PlayerId + "/contacts", contact );
    return ret;
   }

   addPlayerContact(contact: PlayerContactModel ): Observable<ResponseModel>{
    
    let ret = this.http.post<ResponseModel>(this.rootUrl + '/api/load/player/' + contact.PlayerId + "/contacts", contact );
    
    return ret;
   }

  addPlayerAsFavorite(playerId: string ): Observable<ResponseModel>{
  
    let ret = this.http.get<ResponseModel>(this.rootUrl + '/api/players/' + playerId + "/addasfavourite" );
  
    return ret;
  }

  removePlayerAsFavorite(playerId: string ): Observable<ResponseModel>{
    
    let ret = this.http.get<ResponseModel>(this.rootUrl + '/api/players/' + playerId + "/removeasfavourite" );
    
    return ret;
  }

  deletePlayerContact(contact: PlayerContactModel): Observable<any>{
    let ret = this.http.delete(this.rootUrl + '/api/load/player/' + contact.PlayerId + '/contacts/' + contact.ContactId);
    return ret;
   }

   getReportMasterDataForPosition(PositionId: string){
    return this.getReportMasterDataForPositionAndReport(PositionId,'00000000-0000-0000-0000-000000000000');
   }

   getReportMasterDataForOrg(){
    return this.getReportMasterDataForPosition('2');
   }

   getReportMasterDataForPositionAndReport(PositionId: string, ReportId: string){
    let ret = this.http.get<any>(this.rootUrl + '/api/scouting/reportmasterdata/' + PositionId + '/' + ReportId );
    return ret;
   }

   getReportSearchMasterDataForOrg(){
    let ret = this.http.get<any>(this.rootUrl + '/api/scouting/searchmasterdata/true');
    return ret;
   }



   getReportMasterData(PlayerId: string){
     return this.getReportMasterDataReport(PlayerId,'00000000-0000-0000-0000-000000000000','00000000-0000-0000-0000-000000000000');
    
   }

   getReportMasterDataReport(PlayerId: string, GameId: string, ReportId: string){
    let ret = this.http.get<any>(this.rootUrl + '/api/scouting/reportmasterdata/' + PlayerId + '/' + GameId + '/' + ReportId );
    return ret;
   }



   searchReports(params: ReportSearchParameters): Observable<FlowItemViewModel[]>{
    let reports = this.http.post<FlowItemViewModel[]>(this.rootUrl + '/api/scouting/reports/search', params);

    return reports;
  }

  getTagsForPlayer_ByUser(playerId: string): Observable<PlayerTagPlayerViewModel[]> {
    return this.http.get<PlayerTagPlayerViewModel[]>(this.rootUrl + '/api/playertags/GetForPlayerByUser/' + playerId);
  }

  getActivePlayerTags(): Observable<PlayerTagViewModel[]> {
    return this.http.get<PlayerTagViewModel[]>(this.rootUrl + '/api/playertags/active');
  }

  addTagToPlayer(playerId: string, tagId: string): Observable<ResponseModel> {
    return this.http.post<ResponseModel>(this.rootUrl + '/api/playertags/' + playerId + '/' + tagId, null, this.httpOptions);
  }

  removeTagFromPlayer(playerId: string, tagId: string): Observable<ResponseModel> {
    return this.http.delete<ResponseModel>(this.rootUrl + '/api/playertags/' + playerId + '/' + tagId);
  }
}
